/*
 * Copyright (c) 2026.  atagon GmbH.  All rights reserved.
 *
 * This file is part of the atagon codebase and may not be copied,
 *  distributed, or modified without explicit written permission from
 * atagon GmbH. https://www.atagon.com
 */

import React, {useState} from 'react';
import TextInputFormComponent from "./FormComponents/TextInputFormComponent.jsx";
import ValidateDomainTarget from "./Page/ValidateDomainTarget.jsx";
import Unique from "toolbox/unique";
import {rootDomain} from "../config.js";
import Domains from "../Objects/Domains.jsx";
import Strings from "toolbox/strings";
import ButtonComponent from "./BasicInputs/ButtonComponent.jsx";
import UiElementInlineError from "./ErrorHandling/UIElementInlineError.jsx";
import {Notification} from "../Notification.jsx";

function AddDomain({elementId, close}) {
    const [domainName, setDomainName] = useState("")
    const [domainId, setDomainId] = useState(Unique.newInternalId())
    const [moveDomain, setMoveDomain] = useState(false)
    const [uiID, setUiID] = useState(Unique.newInternalId())
    let targetValue = `domain-${domainId}.${rootDomain}`.toLowerCase()

    return (
        <div className={"py-2 space-y-3"}>
            <TextInputFormComponent name={"Domain Name"} value={domainName} onChange={async (value) => {

                setDomainName(value)
                let hostname = value
                try {
                    hostname = hostname.replaceAll("http://", "").replaceAll("https://", "")
                    let url = new URL(`https://${value}`)
                    hostname = url.hostname
                } catch (e) {

                }
                setDomainName(value)

                let result = await Domains("EMPTY").find(hostname)
                console.log(result);
                if (!Strings.isEmpty(result)) {
                    setDomainId(result?.indexKey)
                    setMoveDomain(true)
                } else {
                    setMoveDomain(false)

                }
            }}/>

            {(!moveDomain) && (<>
                <TextInputFormComponent name={"Point CNAME to"} isDisabled
                                        value={targetValue} onChange={(value) => {
                }}/>

                <ValidateDomainTarget domainName={domainName} domainTarget={targetValue}/>

            </>)}

            {(moveDomain) && (<div className={"mt-1"}>
                The domain already exists, move it to this element by pressing Add Domain.
            </div>)}

            <UiElementInlineError uiId={uiID}/>

            <ButtonComponent text={"Add Domain"}
                             className={" mt-2 w-full h-10"}
                             onClick={async () => {
                                 if (domainName === "" || domainName.length <= 3) {
                                      Notification.createError("The domain name is invalid.", "Please check the domain name.", uiID)
                                     return
                                 }
                                 let result
                                 if (moveDomain) {
                                     // change target of existing domain
                                     result = await Domains(domainId).setTarget(elementId)

                                 } else {
                                     // create new domain
                                     result = await Domains(domainId).create(domainName, elementId)
                                 }
                                 console.log(result);
                                 if (!result.success) {
                                      return Notification.createError("Failed to add domain", result.error, uiID)
                                 }
                                 close?.()

                             }}/>


        </div>
    );
}

AddDomain.propTypes = {};

AddDomain.defaultProps = {};


export default AddDomain;